import { z } from "zod";
import { TimepotDate } from "models/TimepotDate";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const UserPaymentSnapshot = z.object({
    amount: z.number().transform((value) => value / 100),
    from: TimepotDate.optional(),
    to: TimepotDate.optional(),
});

export type UserPaymentSnapshot = z.infer<typeof UserPaymentSnapshot>;
